import React, { useState, useEffect, useRef } from 'react';
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom';
import LoginPage from './Pages/Auth/LoginPage';
import RegisterComponenet from './Pages/Auth/RegisterComponent';
import Forgotpassword from './Pages/Auth/ForgotPassword';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import Bootstrap JavaScript
import './assets/css/global/global.scss';
import Layout from './Components/Layout/Layout';
import JGrid from './Components/JGrid/JGrid';
import PlanDashboard from './Pages/PlanDashboard/PlanDashboard';
import RFSDashboard from './Pages/Airline/RFSControl/Dashboard/RFSDashboard';
import RFSNDashboard from './Pages/Airline/RFSControl/Dashboard';
import Dashboard from './Pages/Dashboard/Dashboard';
import HandlerAdmin from './Pages/Dashboard/HandlerAdmin';
// import HandlerSettings from './Pages/Settings/HandlerSettings';
import HUserSettings from './Pages/Settings/HADMIN/UserSettings';
import HStationSettings from './Pages/Settings/HADMIN/StationSettings';
import HWarehouseSettings from './Pages/Settings/HADMIN/WarehouseSettings';
import HTemplateManagement from './Pages/Settings/HADMIN/TemplateManagement';
import SuperAdmin from './Pages/Dashboard/SuperAdmin';
import ServerPage from './Pages/ServerPage/ServerPage';
// import CargoDamage from './Pages/CargoDamage/CargoDamage';
import Stations from './Pages/stations/stations';
import Kpicharts from './Pages/Kpi-Charts/Kpicharts';
import TruckOrder from './Pages/Airline/RFSControl/TruckOrder/TruckOrder';
import OrderTruck from './Pages/Airline/RFSControl/TruckOrder/OrderTruck';
import AWBMonitor from './Pages/Airline/RFSControl/AWBMonitor/AWBMonitor';
import TruckMonitor from './Pages/Airline/RFSControl/TruckMonitor/TruckMonitor';
import OrdersViewDetails from './Pages/Airline/RFSControl/TruckMonitor/OrdersViewDetails';
import RMDetails from './Pages/Airline/RFSControl/TruckMonitor/Details';
import RMODetails from './Pages/Airline/RFSControl/TruckMonitor/OrderDetails';

import Trucking from './Pages/Trucking/Trucking';
import Trucker from './Pages/Trucking/Trucker';

import QuoteRequest from './Pages/Broker/QuoteRequest';
import TQuoteRequest from './Pages/Trucking/QuoteRequest';
import TDashboard from './Pages/Airline/RFSControl/TruckMonitor/Dashboard';
import FQUT from './Pages/Forwarder/Quotation/Quotation';

import QDocMgmt from './Pages/Airline/DocManagement/DocManagement';

import HTruckMonitor from './Pages/Handler/RFSControl/RFSMonitor/TruckMonitor';
import HDashboard from './Pages/Handler/RFSControl/Dashboard/HandlerDashboard';
import SlotDashboard from './Pages/Handler/SlotPlanning/HandlerDashboard';
import HMonitor from './Pages/Handler/RFSControl/Monitor/HandlerMonitor';
import SlotMonitor from './Pages/Handler/SlotPlanning/RFSMonitor/TruckMonitor';
import HOrdersViewDetails from './Pages/Handler/RFSControl/RFSMonitor/OrdersViewDetails';

import AllTrips from './Pages/Handler/SlotPlanning/AllTrips';
import Slot from './Pages/Handler/SlotPlanning/Slot';
import Security from './Pages/Handler/Security/Security';
// import ServiceRecovery from './Pages/ServiceRecovery/ServiceRecovery';
// import UldDamage from './Pages/ULDDamage/UldDamage';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../src/assets/css/responsive.css";
// import "../src/App.scss"; 

import ShipmentPlan from './Components/CreatePlan/ShipmentPlan';
import EditShipmentPlan from './Components/EditPlan/EditShipmentPlan';
import EditULDPlan from './Components/EditPlan/EditULDPlan';
import BookingtruckSchedule from './Pages/Airline/RFSControl/BookingtruckSchedule/BookingtruckSchedule';
import BookingtruckDetails from './Pages/Airline/RFSControl/BookingtruckSchedule/Details';
import TruckOrderDetails from './Pages/Airline/RFSControl/TruckOrder/TruckOrderDetails';
import Planning from './Pages/Airline/RFSControl/BookingtruckSchedule/Planning';
import TruckPlanning from './Pages/Airline/RFSControl/BookingtruckSchedule/TruckPlanning';
// import UserSettings from './Pages/Settings/UserSettings';
// import AirlineSettings from './Pages/Settings/AirlineSettings';
// import RFSControlSettings from './Pages/Settings/AirlineRFSSettings';
// import AirlineStationSettings from './Pages/Settings/Dashboard/StationSettings';
// import AirlineRegionSettings from './Pages/Settings/Dashboard/RegionSettings';
import { NotificationSettings } from './Pages/Settings/RFS/NotificationSettings';
import { StationSettings } from './Pages/Settings/RFS/StationSettings';
import RFSRegionSettings from './Pages/Settings/RFS/RegionSettings';
// import { CarrierSettings } from './Pages/Settings/CarrierSettings';
import TruckerSettings from './Pages/Settings/RFS/TruckerSettings';
// import ULDControlSettings from './Pages/Settings/AirlineULDSettings';
// import ManageUsers from './Pages/Settings/RFS/ManageUsers';
import ManageUserULD from './Pages/Settings/ULD/ManageUsers';
// import AccessibilitySettings from './Pages/Settings/RFS/AccessibilitySettings';
// import UserSpecificSettings from './Pages/Settings/RFS/UserSpecificSettings';
import AccessRights from './Pages/Settings/ULD/AccessRights';
import AddAWB from './Pages/Airline/RFSControl/AWBMonitor/Components/AddAWB';
import AssignAWB from './Pages/Airline/RFSControl/AWBMonitor/Components/AssignAWB';

import FlightMonitor from './Pages/Airline/FlightMonitor/FlightMonitor';
import ATruckMonitor from './Pages/Airline/TruckMonitor/TruckMonitor';

import { GridDetails } from './Pages/PlanDashboard/GridDetails';
import { LoadingPage } from './Pages/LoadingPage/LoadingPage';
import ArchiveGrid from './Components/JGrid/ArchivedGrid'

import Settings from './Pages/Settings/Settings';

import UldstackPlan from './Components/UldstackPlan/UldstackPlan';
import Crud from './Components/CRUD/Crud';
import Sample from './Pages/Sample';

import ULDControl from './Pages/Airline/ULDControl/ULDControl';
import NewStock from './Pages/Airline/ULDControl/components/NewStock';
import NewCharter from './Pages/Airline/ULDControl/components/NewCharter';
import StockAllotment from './Pages/Airline/ULDControl/StockAllotment/StockAllotment';
import ULDFunction from './Pages/Airline/ULDControl/components/ULDFunction';
import MovementHistory from './Pages/Airline/ULDControl/components/MovementHistory';
import MHDetails from './Pages/Airline/ULDControl/components/MHDetails';
import History from './Pages/Airline/ULDControl/History/History';
import Recovery from './Pages/Airline/ULDControl/Recovery/Recovery';
import Invoice from './Pages/Airline/ULDControl/Invoice/Invoice';
import FlightSchedule from './Pages/Airline/ULDControl/FlightSchedule/FlightSchedule';
import AddFlight from './Pages/Airline/ULDControl/FlightSchedule/AddFlight';
import RecoveryDetails from './Pages/Airline/ULDControl/Recovery/RecoveryDetails';
import Charts from './Pages/Charts/ULD/Charts';
import FULDCharts from './Pages/Charts/FULD/Charts';
import ASRCharts from './Pages/Charts/ASR/Charts';
// import ChartsTest from './Pages/Charts/ULD/ChartsTest';
// import ChartsTests from './Pages/Charts/ULD/ChartsTests';
import FDVRegistration from './Pages/Forwarder/DVRegistration/DVRegistration';
import HDVRegistration from './Pages/Handler/DVRegistration/DVRegistration';
import ULDForwarder from './Pages/Forwarder/ULDControl/ULDForwarder';

import DRegistration from './Pages/Forwarder/DVRegistration/Driver';
import VRegistration from './Pages/Forwarder/DVRegistration/Visitor';
import ActiveTrips from './Pages/Forwarder/ULDControl/ActiveTrips';
import FUldDetails from './Pages/Forwarder/ULDControl/FUldDetails';
import FPlanning from './Pages/Forwarder/ULDControl/Planning';
import ULDStock from './Pages/Forwarder/ULDControl/ULDStock';
import BuildUp from './Pages/Forwarder/ULDControl/BuildUp';
import AddULDForwarder from './Pages/Forwarder/ULDControl/Components/AddUldForwarder';
import PlanTrip from './Pages/Forwarder/ULDControl/Components/PlanTrip';
import ActionBuildUp from './Pages/Forwarder/ULDControl/Components/ActionBuildUp';

import FInbound from './Pages/Forwarder/ShipmentManager/Inbound';
import FSPlanning from './Pages/Forwarder/ShipmentManager/Planning';
import FExport from './Pages/Forwarder/ShipmentManager/Export';
import FImport from './Pages/Forwarder/ShipmentManager/Import';
import FShipments from './Pages/Forwarder/ShipmentManager/ShipmentRecords';
import Fquotation from './Pages/Forwarder/ShipmentManager/Quotation';
import Finvoice from './Pages/Forwarder/ShipmentManager/Invoice';
import AddRecord from './Pages/Forwarder/ShipmentManager/Components/AddShipmentRecords';
import EDetails from './Pages/Forwarder/ShipmentManager/Components/ExpectedDetails';
import FCCargo from './Pages/Forwarder/ShipmentManager/Components/Common/CreateCargo';
import FsmLog from './Pages/Forwarder/ShipmentManager/MessageLog';

import { GeneralSettings } from './Pages/Settings/ULD/GeneralSettings';
// import FULDSettings from './Pages/Settings/FULDSettings';
// import ForwarderSettings from './Pages/Settings/ForwarderSettings';
// import FSMSettings from './Pages/Settings/FSMSettings';
import FGeneralSettings from './Pages/Settings/FULD/GeneralSettings';
import FUserSettings from './Pages/Settings/FDASH/UserSettings';
import FStationSettings from './Pages/Settings/FDASH/StationSettings';
import FDepartmentSettings from './Pages/Settings/FDASH/DepartmentSettings';
import FTimeZoneSettings from './Pages/Settings/FDASH/TimeZoneSettings';
import FSGSettings from './Pages/Settings/FSM/GeneralSettings';
import FSRecordSettings from './Pages/Settings/FSM/ShipmentRecordSettings';
import FSCategoryInvoice from './Pages/Settings/FSM/AddCategoryInvoice';
import FSCustomerSettings from './Pages/Settings/FSM/CustomerSettings';
import FSLocationSettings from './Pages/Settings/FSM/LocationSettings';
import FSStationRatesSettings from './Pages/Settings/FSM/StationRatesSettings';
import FSAirFreightSettings from './Pages/Settings/FSM/AirFreightSettings';
import FSQuotationSettings from './Pages/Settings/FSM/QuotationSettings';
import FSAirfreightRates from './Pages/Settings/FSM/AirfreightRates';
import FSStationRates from './Pages/Settings/FSM/StationRates';
import RegionSettings from './Pages/Settings/ULD/RegionSettings';
import AccessRightsSettings from './Pages/Settings/ULD/AccessRightsSettings';
import ULDNotificationSettings from './Pages/Settings/ULD/NotificationSettings';
import InactiveUldSettings from './Pages/Settings/ULD/InactiveUldSettings';
import ULDStationSettings from './Pages/Settings/ULD/StationSettings';
import ULDMessageSettings from './Pages/Settings/ULD/MessageSettings';
import ReportSettings from './Pages/Settings/ULD/ReportSettings';
import StockAllotmentSettings from './Pages/Settings/ULD/StockAllotmentSettings';
import SubmitForm from './Pages/EmailSubmit/SubmitForm';
import TruckConfirm from './Pages/EmailSubmit/TruckConfirmForm';
import TTracker from './Pages/RfsTimeTracker/RfsTimeTracker';
import DVReg from './Pages/EmailSubmit/DriverVisitorRegistration';


import PrivateRoutes from "./useAuth/privateRoutes";
import {
  useAuthSession, useAuth, useAuthRFS, useAuthULD, useAuthFTM, useAuthTKM, useAuthEmail, useAuthASR, useAuthHSR,
  useAuthAirline, useAuthHandler, useAuthTrucking, useAuthHRFS, useAuthForwarder,
  useAuthFSHP, useAuthFULD, useAuthTEmail, useAuthHSPL, useAuthTTracker, useAuthSAdmin, useAuthBroker,
  useAuthServer, useAuthFDVR, useAuthNTOKEN, useAuthQMS, useAuthHULD, useAuthHDVR
} from './useAuth/useAuth';
import ASR from './Pages/Airline/ServiceRecovery/ServiceRecovery';
import ARFSM from './Pages/Airline/RFSMonitor/RfsMonitor';

import ServiceRecovery from './Pages/Airline/ServiceRecovery/ServiceRecovery';
// import EditTask from './Pages/Airline/ServiceRecovery/EditTask';
import ASRReadSign from './Pages/Airline/DocManagement/ReadSign';
// import AddRecovery from './Pages/Airline/ServiceRecovery/AddRecovery';
// import OverviewDetails from './Pages/Airline/ServiceRecovery/OverviewDetails';
// import MsgRecovery from './Pages/Airline/ServiceRecovery/MessageRecovery';
// import UpdateRecovery from './Pages/Airline/ServiceRecovery/UpdateRecovery';
import HandlerRecovery from './Pages/Handler/ServiceRecovery/ServiceRecovery';
import EditHandlerRecovery from './Pages/Handler/ServiceRecovery/EditHandlerRecovery';
import HOverviewDetails from './Pages/Handler/ServiceRecovery/OverviewDetails';
import UpdateHandlerRecovery from './Pages/Handler/ServiceRecovery/EditHandlerRecovery';
// import UpdateRecoveryCase from './Pages/Airline/ServiceRecovery/UpdateRecoveryCase';
import PlanningDashboard from './Pages/Handler/SlotPlanning/PlanningDashboard';

import HULDControl from './Pages/Handler/ULDControl/ULDControl';
import HMovementHistory from './Pages/Handler/ULDControl/components/MovementHistory';
import HMHDetails from './Pages/Handler/ULDControl/components/MHDetails';
// import HUCM from './Pages/Handler/ULDControl/UCM/UCM';
// import HSCM from './Pages/Handler/ULDControl/SCM/SCM';
// import HLUC from './Pages/Handler/ULDControl/LUC/LUC';
import HDetails from './Pages/Handler/ULDControl/components/Details';
import HULDFunction from './Pages/Handler/ULDControl/components/ULDFunction';
// import HULDSettings from './Pages/Settings/HandlerULDSettings';
import HSRCharts from './Pages/Charts/HSR/Charts';

// import SPLSettings from './Pages/Settings/SlotPlanningSettings';
import DoorConfiguration from './Pages/Settings/SPL/DoorConfiguration';
import SlotSettings from './Pages/Settings/SPL/SlotSettings';
import ResourceSettings from './Pages/Settings/SPL/ResourceSettings';
import DoorsAvailibility from './Pages/Settings/SPL/DoorsAvailibility'
import HTruckerSettings from './Pages/Settings/SPL/TruckerSetting'
import HAirlineSettings from './Pages/Settings/SPL/AirlineSetting'

import AddHRecovery from './Pages/Handler/ServiceRecovery/AddRecovery';
import MessageRecovery from './Pages/Handler/ServiceRecovery/MessageRecovery';
import HEditTask from './Pages/Handler/ServiceRecovery/EditTask';
// import HSRSettings from './Pages/Settings/HSRSettings';
import RecoveryStationSettings from './Pages/Settings/ASR/RecoveryStationSettings';
import RecoveryTemplateManagement from './Pages/Settings/Dashboard/TemplateManagement';
import FileManagement from './Pages/Settings/ASR/FileManagementSettings';
import ASRGSettings from './Pages/Settings/ASR/GeneralSettings';
import ASRUSettings from './Pages/Settings/ASR/UserSettings';
import ASRDSettings from './Pages/Settings/ASR/DepartmentSettings';
import ASRUDSettings from './Pages/Settings/ASR/UserDepartmentSettings';
import HSRGSettings from './Pages/Settings/HSR/GeneralSettings';
import HandlerStationSettings from './Pages/Settings/HSR/RecoveryStationSettings';
import HUpdateRecoveryCase from './Pages/Handler/ServiceRecovery/UpdateRecoveryCase';
import RecoveryStationDetails from './Pages/Settings/ASR/RecoveryStationDetails';
import RecoverySettings from './Pages/Settings/ASR/RecoverySettings';
// import ASRSettings from './Pages/Settings/ASRSettings';

import Main from './Pages/Dashboard/Main';
import Home from './Pages/Auth/UrlCheck';
import { HasAnyAuthToken } from './Utils/AuthToken';
import { ExtractSession } from './useAuth/SessionExtract';
import { decrypt } from './Utils/cryptoStorage';

let isRedirecting = false;
// import PublicRoutes from "./useAuth/publicRoutes";


const App = () => {

  const isMounted = useRef(false);
  const history = useHistory();
  const location = useLocation();
  const [isAuth, setIsAuth] = useState();
  const [authLoading, setAuthLoading] = useState(true);
  const [authData, setAuthData] = useState();

  const isAuthenticatedSAdmin = useAuthSAdmin();
  const isAuthenticatedServer = useAuthServer();
  const isAuthenticatedAirline = useAuthAirline();
  const isAuthenticatedHandler = useAuthHandler();
  const isAuthenticatedForwarder = useAuthForwarder();
  const isAuthenticated = useAuth();
  const isAuthenticatedRFS = useAuthRFS();
  const isAuthenticatedFTM = useAuthFTM();
  const isAuthenticatedTKM = useAuthTKM();
  const isAuthenticatedHRFS = useAuthHRFS();
  const isAuthenticatedHSPL = useAuthHSPL();
  const isAuthenticatedTrucking = useAuthTrucking();
  const isAuthenticatedULD = useAuthULD();
  const isAuthenticatedEMAIL = useAuthEmail();
  const isAuthenticatedTEMAIL = useAuthTEmail();
  const isAuthenticatedTTracker = useAuthTTracker();
  const isAuthenticatedASR = useAuthASR();
  const isAuthenticatedHSR = useAuthHSR();
  const isAuthenticatedHULD = useAuthHULD();
  const isAuthenticatedFSHP = useAuthFSHP();
  const isAuthenticatedFULD = useAuthFULD();
  const isAuthenticatedBRK = useAuthBroker();
  const isAuthenticatedFDVR = useAuthFDVR();
  const isAuthenticatedHDVR = useAuthHDVR();
  const isAuthenticatedQMS = useAuthQMS();
  // const isAuthenticatedNTOKEN = useAuthNTOKEN();
  // localStorage.setItem("authToken", "Bearer jwtToken");
  //@pk no token
  // useEffect(() => {
  //   if (isMounted.current) return;
  //   if (
  //     !localStorage.getItem('ULD') &&
  //     !localStorage.getItem('token') &&
  //     !localStorage.getItem('RFS') &&
  //     !localStorage.getItem('FTM') &&
  //     !localStorage.getItem('TKM') &&
  //     !localStorage.getItem('EMAIL') &&
  //     !localStorage.getItem('ASR') &&
  //     !localStorage.getItem('SAToken') &&
  //     !localStorage.getItem('airlinetoken') &&
  //     !localStorage.getItem('service_recovery_token') &&
  //     !localStorage.getItem('Trucking') &&
  //     !localStorage.getItem('SPL') &&
  //     !localStorage.getItem('QMS') &&
  //     !localStorage.getItem('TEMAIL') &&
  //     !localStorage.getItem('TTRACKER') &&
  //     !localStorage.getItem('DVR') &&
  //     !localStorage.getItem('ServerIWI') &&
  //     !localStorage.getItem('NO_TOKEN')
  //   ) {
  //     // window.location.href = "https://portal.trucking.aero/Forms/index";
  //     window.location.href = "/Login";
  //   }
  //   isMounted.current = true;
  // }, []);
  //@pk no token
  useEffect(() => {
    const ExtractSession = async () => {
      try {
        const encryptedData = sessionStorage.getItem('__A-');

        if (encryptedData) {
          const data = await decrypt(encryptedData);

          setAuthData(data);

          if (data?.token) {
            setIsAuth(true);
          }
        }
      } catch (error) {
        console.error("Session decrypt error:", error);
      } finally {
        setAuthLoading(false);
      }
    };

    ExtractSession();
  }, []);
  // useEffect(() => {
  //   // const checkSession = ExtractSession('auth');

  //   const ExtractSession = async () => {
  //     const encryptedData = sessionStorage.getItem('__A-');

  //     if (!encryptedData) {
  //       return null;
  //     }

  //     const data = await decrypt(encryptedData);
  //     setAuthData(data)
  //     if (data?.token) {
  //       isMounted.current = true;
  //       setIsAuth(true);
  //     }
  //   }
  //   ExtractSession()
  //   // const user1 = () => ExtractSession("auths").then((data) => {
  //   //   if (data?.token) {
  //   //     setAuthData(data)
  //   //     // setIsAuth(true)
  //   //   } else {
  //   //     // setIsAuth(false)
  //   //   }
  //   // });
  //   // user1()

  //   // setIsAuth(HasAnyAuthToken());

  //   // const user = JSON.parse(sessionStorage.getItem('auth'));
  //   // if (user?.token) {
  //   //   setIsAuth(true);
  //   // }
  //   // if(checkSession?.token) {
  //   //   setIsAuth(true);
  //   // }
  // }, []);
  let idleTimeout;

  const idleTime = 30 * 60 * 1000; // 30 minutes in milliseconds

  const onIdle = () => {
    console.log("You have been idle for 30 minutes.");
    const logUrl = localStorage.getItem('LogOut');
    localStorage.clear();
    // window.location.replace(logUrl || process.env.REACT_APP_LOGIN_URL);
    history.push('/')
  };

  const resetIdleTimer = () => {
    clearTimeout(idleTimeout);
    idleTimeout = setTimeout(onIdle, idleTime); // Restart timer on activity
  };

  useEffect(() => {
    // List of events to monitor for user activity
    const events = ['mousemove', 'keypress', 'touchstart'];

    // Attach event listeners
    events.forEach(event => window.addEventListener(event, resetIdleTimer));
    window.addEventListener('load', resetIdleTimer); // Start timer on page load

    // Start initial idle timer
    resetIdleTimer();

    // Clean up event listeners on component unmount
    return () => {
      events.forEach(event => window.removeEventListener(event, resetIdleTimer));
      window.removeEventListener('load', resetIdleTimer);
      clearTimeout(idleTimeout); // Clear timeout when component unmounts
    };
  }, []);

  // Browser Close
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     // Only clear localStorage if it's not a redirection
  //     if (!isRedirecting) {
  //       localStorage.clear();
  //     }
  //   };

  //   // Attach the event listener
  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   // Cleanup the event listener on component unmount
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  if (authLoading) {
    return <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>;
  }
  const logLoc = location.pathname
  console.log('App', logLoc);
  return (
    <>
      <Switch>
        {/* Public Routes */}
        <Route exact path="/" component={Home} />
        <Route exact path="/registerPage" component={RegisterComponenet} />
        {!isAuth && logLoc === '/Login' && <Route exact path="/Login" component={LoginPage} />}
        {isAuth && logLoc === '/Login' && <Redirect to={authData?.loc ?? '/'} />}
        <Route exact path="/Confirmation" component={LoadingPage} />
        {/* <Route exact path="/" component={Main} /> */}

        <Route exact path="/Crud" component={Crud} />

        <Route exact path="/forgotpassword" component={Forgotpassword} />
        {/* <Route exact path = "/dashboard" component={AdminDashboard}/> */}
        {/* <Route exact path="/Dashboard" component={Dashboard} /> */}
        {/* {(isAuthenticatedAirline || isAuthenticatedHandler || isAuthenticatedForwarder) && (
          <>
          <Route exact path="/Dashboard" component={Dashboard} />
          </>
          )} */}
        <Route exact path="/Driver-Visitor-Registration" component={DVReg} />
        {isAuth &&
          <>
            {/* {console.log('isAuthenticatedSAdmin', authData?.login_user_type)} */}
            <Route exact path="/Settings" component={Settings} />
            {/* {isAuthenticatedSAdmin && ( */}
            {(authData?.login_user_type === 'SA' && authData?.org_type === 'SA') && (
              <>
              {/* {console.log('authData', authData)} */}
                <Route exact path="/SuperAdmin" component={SuperAdmin} />
              </>
            )}
            {/* {isAuthenticatedNTOKEN && (
          <>
            <Route exact path="/Driver-Visitor-Registration" component={DVReg} />
          </>
        )} */}
            {isAuthenticatedServer && (
              <>
                <Route exact path="/Server" component={ServerPage} />
              </>
            )}
            {/* {isAuthenticatedAirline && ( */}
            {authData?.org_type === 'A' && (
              <>
                <Route exact path="/Dashboard" component={Dashboard} />
                <Route exact path="/ServiceRecovery" component={ASR} />
                <Route exact path="/RFSMonitor" component={ARFSM} />
                {/* <Route exact path="/StationSettings" component={AirlineStationSettings} />
                        <Route exact path="/RegionSettings" component={AirlineRegionSettings} />
                        <Route exact path="/TemplateManagementSettings" component={RecoveryTemplateManagement} /> */}
              </>
            )}
            {isAuthenticatedQMS && (
              <>
                <Route exact path="/DocumentManagement" component={QDocMgmt} />
                <Route exact path="/ReadSign" component={ASRReadSign} />
              </>
            )}
            {/* {isAuthenticatedForwarder && ( */}
            {authData?.org_type === 'E' && (
              <>
                <Route exact path="/Dashboard" component={Dashboard} />

                {/* <Route exact path="/ForwarderSettings" component={ForwarderSettings} /> */}
                {/* <Route exact path="/UserSettings" component={FUserSettings} />
                                <Route exact path="/StationSettings" component={FStationSettings} />
                                <Route exact path="/DepartmentSettings" component={FDepartmentSettings} />
                                <Route exact path="/TimeZoneSettings" component={FTimeZoneSettings} />
                                <Route exact path="/DriverVisitorSettings" component={FDriverVisitorSettings} /> */}
              </>
            )}
            {/* {(isAuthenticatedForwarder) && (
                    <>
                      <Route exact path="/ForwarderDashboard" component={Dashboard} />
                    </>
                  )} */}
            {/* {isAuthenticatedHSPL && (
              <>
                <Route exact path="/PlanningDashboard" component={PlanningDashboard} />
                <Route exact path="/HandlerDashboard" component={SlotDashboard} />
                <Route exact path="/AllTrips" component={AllTrips} />
                <Route exact path="/HandlerTruckMonitor" component={SlotMonitor} />
                <Route exact path="/HandlerTruckMonitor/OrdersViewDetails" component={HOrdersViewDetails} /> */}

            {/* <Route exact path="/TruckingRFS/OrdersView" component={HOrdersView} /> */}
            {/* <Route exact path="/DoorConfiguration" component={DoorConfiguration} />
                                <Route exact path="/SlotSettings" component={SlotSettings} />
                                <Route exact path="/ResourceSettings" component={ResourceSettings} />
                                <Route exact path="/DoorsAvailability" component={DoorsAvailibility} />
                                <Route exact path="/TruckerSettings" component={HTruckerSettings} />
                                <Route exact path="/AirlineSettings" component={HAirlineSettings} /> */}

            {/* </>
            )} */}
            {authData?.org_type === 'H' && (
              <>
                <Route exact path="/Dashboard" component={Dashboard} />
                <Route exact path="/HandlerAdmin" component={HandlerAdmin} />
                <Route exact path="/SlotPlanning" component={Slot} />
                <Route exact path="/Security" component={Security} />
                <Route exact path="/ULDControl" component={HULDControl} />
                {/* <Route exact path="/UserSettings" component={HUserSettings} />
                                <Route exact path="/StationSettings" component={HStationSettings} />
                                <Route exact path="/WarehouseSettings" component={HWarehouseSettings} />
                                <Route exact path="/TemplateManagementSettings" component={HTemplateManagement} /> */}


                {/* <Route exact path="/HandlerDashboard" component={Dashboard} /> */}

                {/* <Route exact path="/HandlerRecovery" component={HandlerRecovery} />
                                <Route exact path="/EditHandlerRecovery" component={EditHandlerRecovery} />
                                <Route exact path="/MessageRecovery" component={MessageRecovery} /> */}

                {/* <Route exact path="/AirlineSettings" component={AirlineSettings} />
                                <Route exact path="/StationSettings" component={AirlineStationSettings} />
                                <Route exact path="/RegionSettings" component={AirlineRegionSettings} /> */}
              </>
            )}
            {/* {isAuthenticatedTrucking && ( */}
            {authData?.org_type === 'T' && (
              <>
                <Route exact path="/TruckMonitor" component={TruckMonitor} />
                <Route exact path="/QuoteRequest" component={TQuoteRequest} />
                <Route exact path="/Dashboard" component={TDashboard} />
                <Route exact path="/TruckMonitor/OrdersViewDetails" component={OrdersViewDetails} />
                <Route exact path="/OrderDetails" component={RMODetails} />
                {/* <Route exact path="/Trucking" component={Trucking} /> */}
                <Route exact path="/Trucker" component={Trucker} />
              </>
            )}
            {isAuthenticatedBRK && (
              <>
                <Route exact path="/QuoteRequest" component={QuoteRequest} />
              </>
            )}

            {/* {isAuthenticatedASR && (
              <>
                <Route exact path="/AddRecovery" component={AddRecovery} />
                <Route exact path="/OverviewDetails" component={OverviewDetails} />
                <Route exact path="/MessageRecovery" component={MsgRecovery} />
                <Route exact path="/UpdateRecovery" component={UpdateRecovery} />
                <Route exact path="/ReadSign" component={ASRReadSign} />
                <Route exact path="/EditTask" component={EditTask} /> */}

            {/* <Route exact path="/RecoverySettings" component={RecoverySettings} />
                                <Route exact path="/RecoveryStationSettings" component={RecoveryStationSettings} />
                                <Route exact path="/TemplateManagementSettings" component={RecoveryTemplateManagement} />
                                <Route exact path="/FileManagementSettings" component={FileManagement} />
                                <Route exact path="/UserSettings" component={ASRUSettings} />
                                <Route exact path="/GeneralSettings" component={ASRGSettings} />
                                <Route exact path="/DepartmentSettings" component={ASRDSettings} />
                                <Route exact path="/UserDepartmentSettings" component={ASRUDSettings} />
                                <Route exact path="/RecoveryStationDetails" component={RecoveryStationDetails} /> */}

            {/* <Route exact path="/ServiceRecoveryCharts" component={ASRCharts} />

                <Route exact path="/UpdateHandlerRecovery" component={UpdateHandlerRecovery} />
                <Route exact path="/UpdateRecoveryCase" component={UpdateRecoveryCase} />
              </>
            )} */}

            {/* {isAuthenticatedHULD && (
              <>
                <Route exact path="/ULDControl" component={HULDControl} />
              </>
            )} */}

            {/* {isAuthenticatedHSR && ( */}
            {authData?.org_type === 'H' && (
              <>
                <Route exact path="/ServiceRecovery" component={HandlerRecovery} />
                <Route exact path="/OverviewDetails" component={HOverviewDetails} />{/* sourav */}
                <Route exact path="/AddRecovery" component={AddHRecovery} />
                <Route exact path="/EditHandlerRecovery" component={EditHandlerRecovery} />
                <Route exact path="/MessageRecovery" component={MessageRecovery} />
                <Route exact path="/EditTask" component={HEditTask} />
                <Route exact path="/ServiceRecoveryCharts" component={HSRCharts} />

                {/* <Route exact path="/ServiceRecoverySettings" component={HSRSettings} /> */}
                {/* <Route exact path="/GeneralSettings" component={HSRGSettings} />
                      <Route exact path="/RecoveryStationSettings" component={HandlerStationSettings} /> */}
                <Route exact path="/UpdateRecoveryCase" component={HUpdateRecoveryCase} />
              </>
            )}
            {/* Public Routes */}

            {/* Private Routes */}
            {isAuthenticatedEMAIL && (<Route exact path="/Confirmation-form" component={SubmitForm} />)}
            {authData?.TEMAIL && (<Route exact path="/Truck-Confirmation-form" component={TruckConfirm} />)}
            {isAuthenticatedTTracker && (<Route exact path="/RFS-Time-Tracker" component={TTracker} />)}

            {isAuthenticated && (
              <>
                <Route exact path="/planDashboard" component={PlanDashboard} />
                <Route exact path="/Archive" component={ArchiveGrid} />
                <Route exact path="/ShipmentPlan" component={ShipmentPlan} />
                <Route exact path="/EditShipmentPlan" component={EditShipmentPlan} />
                {/* <Route exact path="/UldstackPlan" component={UldstackPlan} /> */}
                <Route exact path="/EditULDPlan" component={EditULDPlan} />
                <Route exact path="/jgrid" component={JGrid} />
                <Route exact path="/gridDetails" component={GridDetails} />
                {/* <Route exact path="/UserSettings" component={UserSettings} /> */}
              </>
            )}
            {/* {isAuthenticatedHRFS && ( */}
            {authData?.org_type === 'H' && (
              <>
                <Route exact path="/HandlerTruckMonitor" component={SlotMonitor} />
                {/* <Route exact path="/HandlerTruckMonitor" component={HTruckMonitor} /> */}
                <Route exact path="/HandlerDashboard" component={HDashboard} />
                <Route exact path="/HandlerMonitor" component={HMonitor} />
                <Route exact path="/HandlerTruckMonitor/OrdersViewDetails" component={HOrdersViewDetails} />
              </>
            )}
            {/* {isAuthenticatedRFS && ( */}
            {authData?.org_type === 'A' && (
              <>
                <Route exact path="/BookingtruckSchedule" component={BookingtruckSchedule} />
                <Route exact path="/BookingtruckDetails" component={BookingtruckDetails} />
                <Route exact path="/BookingtruckDetails/Planning" component={Planning} />
                <Route exact path="/BookingtruckDetails/TruckPlanning" component={TruckPlanning} />
                <Route exact path="/TruckOrder" component={TruckOrder} />
                <Route exact path="/TruckOrderDetails" component={TruckOrderDetails} />
                <Route exact path="/OrderTruck" component={OrderTruck} />
                <Route exact path="/kpicharts" component={Kpicharts} />
                <Route exact path="/stations" component={Stations} />

                {/* <Route exact path="/RFSControlSettings" component={RFSControlSettings} /> */}
                {/* <Route exact path="/NotificationSettings" component={NotificationSettings} />
                      <Route exact path="/StationSettings" component={StationSettings} />
                      <Route exact path="/CarrierSettings" component={CarrierSettings} />
                      <Route exact path="/TruckerSettings" component={TruckerSettings} />
                      <Route exact path="/RegionSettings" component={RFSRegionSettings} /> */}

                <Route exact path="/AWBManager" component={AWBMonitor} />
                <Route exact path="/AWBManager/AddAWB" component={AddAWB} />
                <Route exact path="/AWBManager/AssignAWB" component={AssignAWB} />

                <Route exact path="/TruckingDashboard" component={RFSDashboard} />
                <Route exact path="/RFSDashboard" component={RFSNDashboard} />

                <Route exact path="/TruckMonitor" component={TruckMonitor} />
                <Route exact path="/TruckMonitor/OrdersViewDetails" component={OrdersViewDetails} />
                <Route exact path="/TruckMonitor/Details" component={RMDetails} />
                <Route exact path="/OrderDetails" component={RMODetails} />

                {/* <Route exact path="/ULDControl" component={ULDControl} />
                      <Route exact path="/ULDControl/AddStock" component={NewStock} />
                      <Route exact path="/ULDControl/NewCharter" component={NewCharter} />
                      <Route exact path="/ULDControl/ULDFunction" component={ULDFunction} />
                      <Route exact path="/ULDControl/StationTransfer" component={ULDFunction} />
                      <Route exact path="/ULDControl/ULDReceived" component={ULDFunction} />
                      <Route exact path="/ULDControl/MovementHistory" component={MovementHistory} />
                      <Route exact path="/ULDControl/MovementHistorydetais" component={MHDetails} />
                      <Route exact path="/History" component={History} /> */}

                {/* <Route exact path="/ManageUsers" component={ManageUsers} /> */}
                {/* <Route exact path="/AccessibilitySettings" component={AccessibilitySettings} />
                      <Route exact path="/UserSpecificSettings" component={UserSpecificSettings} /> */}
              </>
            )}
            {isAuthenticatedFTM && (
              <>
                <Route exact path="/FlightMonitor" component={FlightMonitor} />
              </>
            )}
            {isAuthenticatedTKM && (
              <>
                <Route exact path="/TruckMonitor" component={ATruckMonitor} />
              </>
            )}
            {/* {isAuthenticatedFSHP && ( */}
            {authData?.org_type === 'E' && (
              <>
                <Route exact path="/ForwarderShipments/Inbound" component={FInbound} />
                <Route exact path="/ForwarderShipments/Planning" component={FSPlanning} />
                <Route exact path="/ForwarderShipments/Export" component={FExport} />
                <Route exact path="/ForwarderShipments/Import" component={FImport} />
                <Route exact path="/ForwarderShipments/ShipmentRecords" component={FShipments} />
                <Route exact path="/ForwarderShipments/quotation" component={Fquotation} />
                <Route exact path="/ForwarderShipments/Invoice" component={Finvoice} />
                <Route exact path="/ForwarderShipments/Log" component={FsmLog} />
                <Route exact path="/ForwarderShipments/AddShipmentRecords" component={AddRecord} />
                <Route exact path="/ForwarderShipments/ExpectedDetails" component={EDetails} />
                <Route exact path="/ForwarderShipments/CreateCargo" component={FCCargo} />
                {/* <Route exact path="/ShipmentManagerSettings" component={FSMSettings} /> */}
                <Route exact path="/Quotation" component={FQUT} />
                {/* <Route exact path="/GeneralSettings" component={FSGSettings} />
                      <Route exact path="/ShipmentRecordSettings" component={FSRecordSettings} />
                      <Route exact path="/AddCategoryInvoice" component={FSCategoryInvoice} />
                      <Route exact path="/CustomerSettings" component={FSCustomerSettings} />
                      <Route exact path="/LocationSettings" component={FSLocationSettings} />
                      <Route exact path="/QuotationSettings" component={FSQuotationSettings} />
                      <Route exact path="/AirfreightRates" component={FSAirfreightRates} />
                      <Route exact path="/StationRates" component={FSStationRates} /> */}
              </>
            )}
            {/* {isAuthenticatedFULD && ( */}
            {authData?.org_type === 'E' && (
              <>
                <Route exact path="/ULDForwarder" component={ULDForwarder} />
                {/* <Route exact path="/ULDForwarder/ActiveTrips" component={ActiveTrips} />
                          <Route exact path="/ULDForwarder/Details" component={FUldDetails} />
                          <Route exact path="/ULDForwarder/Planning" component={FPlanning} />
                          <Route exact path="/ULDForwarder/ULDStock" component={ULDStock} />
                          <Route exact path="/ULDForwarder/BuildUp" component={BuildUp} />
                          <Route exact path="/ULDForwarder/AddULD" component={AddULDForwarder} />
                          <Route exact path="/ULDForwarder/PlanTrip" component={PlanTrip} />
                          <Route exact path="/ULDForwarder/ActionBuildUp" component={ActionBuildUp} />
                          <Route exact path="/Charts" component={FULDCharts} />
                          <Route exact path="/ForwarderULDSettings" component={FULDSettings} /> */}
                {/* <Route exact path="/GeneralSettings" component={FGeneralSettings} /> */}
                {/* <Route exact path="/UserSettings" component={FUserSettings} /> */}
              </>
            )}
            {/* {isAuthenticatedFDVR && ( */}
            {authData?.org_type === 'E' && (
              <>
                <Route exact path="/DVRegistration" component={FDVRegistration} />
                {/* <Route exact path="/DVRegistration/Driver" component={DRegistration} />
                          <Route exact path="/DVRegistration/Visitor" component={VRegistration} /> */}
                {/* <Route exact path="/ULDForwarder/Details" component={FUldDetails} /> */}
              </>
            )}
            {/* {isAuthenticatedHDVR && ( */}
            {authData?.org_type === 'H' && (
              <>
                <Route exact path="/DVRegistration" component={HDVRegistration} />
              </>
            )}
            {/* {isAuthenticatedULD && ( */}
            {authData?.org_type === 'A' && (
              <>
                <Route exact path="/ULDControl" component={ULDControl} />
                <Route exact path="/ULDControl/AddStock" component={NewStock} />
                <Route exact path="/ULDControl/NewCharter" component={NewCharter} />
                <Route exact path="/ULDControl/ULDFunction" component={ULDFunction} />
                <Route exact path="/ULDControl/StationTransfer" component={ULDFunction} />
                <Route exact path="/ULDControl/ULDReceived" component={ULDFunction} />
                <Route exact path="/ULDControl/MovementHistory" component={MovementHistory} />
                <Route exact path="/ULDControl/MovementHistorydetails" component={MHDetails} />
                <Route exact path="/History" component={History} />
                <Route exact path="/FlightSchedule" component={FlightSchedule} />
                <Route exact path="/FlightSchedule/AddFlight" component={AddFlight} />
                <Route exact path="/Invoice" component={Invoice} />
                <Route exact path="/Recovery" component={Recovery} />
                <Route exact path="/RecoveryDetails" component={RecoveryDetails} />
                <Route exact path="/Charts" component={Charts} />
                <Route exact path="/StockAllotment" component={StockAllotment} />
                {/* <Route exact path="/ChartsTest" component={ChartsTest} /> */}
                {/* <Route exact path="/ChartsTests" component={ChartsTests} /> */}
                {/* <Route exact path="/kpicharts" component={Kpicharts} /> */}


                {/* <Route exact path="/ULDControlSettings" component={ULDControlSettings} /> */}
                {/* <Route exact path="/UserSettings" component={ManageUserULD} />
                      <Route exact path="/AccessRights" component={AccessRights} />
                      <Route exact path="/GeneralSettings" component={GeneralSettings} />
                      <Route exact path="/RegionSettings" component={RegionSettings} />
                      <Route exact path="/AccessRightsSettings" component={AccessRightsSettings} />
                      <Route exact path="/NotificationSettings" component={ULDNotificationSettings} />
                      <Route exact path="/InactiveUldSettings" component={InactiveUldSettings} />
                      <Route exact path="/StationSettings" component={ULDStationSettings} />
                      <Route exact path="/MessageSettings" component={ULDMessageSettings} />
                      <Route exact path="/ReportSettings" component={ReportSettings} />
                      <Route exact path="/StockAllotmentSettings" component={StockAllotmentSettings} /> */}
                {/* <Route exact path="/Sample" component={Sample} /> */}
              </>
            )}

          </>
        }

        {!isAuth && <Redirect to="/" />}
        {/* {!{!isAuth && <Redirect to="/" />}isAuth && <Route exact path="/" component={Home} />} */}

        {/* <Route exact path="/CargoDamage" component={CargoDamage} /> */}
        {/* <Route exact path="/UldDamage" component={UldDamage} /> */}
        {/* <Route exact path="/ServiceRecovery" component={ServiceRecovery} /> */}




        {/* </PrivateRoutes> */}

        {/* Private Routes */}


      </Switch >
    </>
  );
}

export const setRedirecting = (value) => {
  isRedirecting = value;
};

export default App;